import React from 'react'
import { Link } from 'react-router-dom'
export default function Squaretwo() {
  return (
    <div className='section bg-gradient-new-reverse'>
      <div className='container  '>
        <div className='row'>
          <div className='col-lg-12 text-center ' style={{ paddingBottom: "7rem", borderRadius: "48px", background: "linear-gradient(to right, #F7B733, #FC4A1A )" }}>

            <p className='whychoose' style={{ marginTop: "100px" }}>Get your headshot today!</p>
            <p className="inclusive mb-0"> Your professional corporate business headshots are just a few click away. Dont miss out on <br /> the
              opportunity to showcase your teams best image - get your AI generatd headshots now!   </p>

            <div className='row'>
              <div className='col-md-12 d-flex justify-content-center mt-4'>
                <Link to="/Signup">
                  <div className="squr2btn">
                    <spna className="squr2span">
                      CREATE YOURS NOW

                    </spna>
                  </div>
                </Link>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  )
}
